module.exports = __webpack_public_path__ + "img/四川天府新区大林幼儿园.b6cccad8.jpg";